import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SERVER_BASE_URL } from '../../../environments/environment';
import { CurrencyCode } from '@app/model/currency';
import {
  LeqType,
  PaymentRequestDto,
} from '@app/model/payment-request/payment-request.dto';

@Injectable({
  providedIn: 'root',
})
export class LeqService {
  kalpAnswersFI: KalpAnswersFI;
  kalpAnswersNO: KalpAnswersNO;

  constructor(private http: HttpClient) {}

  public getKalpAnswersFI(): KalpAnswersFI {
    return this.kalpAnswersFI;
  }

  public setKalpAnswersFI(newKalpAnswers: KalpAnswersFI): void {
    this.kalpAnswersFI = newKalpAnswers;
  }

  public getKalpAnswersNO(): KalpAnswersNO {
    return this.kalpAnswersNO;
  }

  public setKalpAnswersNO(newKalpAnswers: KalpAnswersNO): void {
    this.kalpAnswersNO = newKalpAnswers;
  }

  updateLeq(leq: LeqFormDto) {
    this.http.post(`${SERVER_BASE_URL}/credit/leq/update`, leq, {
      withCredentials: true,
    });
  }

  fetchLeq(): Promise<LeqInfoDto> {
    return this.http
      .get<LeqInfoDto>(`${SERVER_BASE_URL}/credit/leq/get`, {
        withCredentials: true,
      })
      .toPromise();
  }

  submitLeq(leq: LeqFormDto) {
    return this.http.post(`${SERVER_BASE_URL}/credit/leq/submitV2`, leq, {
      withCredentials: true,
    });
  }

  getSelectedMethodLeqType(
    selectedMethodId: string,
    paymentRequest: PaymentRequestDto
  ): LeqType {
    return paymentRequest.availableMethods.find(
      (m) => m.id === selectedMethodId
    ).requiredLeqType;
  }
}

export class LeqInfoDto {
  numberOfChildren: number;
  creditCosts: number;
  housingCosts: number;
  income: number;
  miscExpenses: number;
  employment: Employment;
  status: KalpStatus;
  studentLoan: number;
  housingType: Housing;
}

export class LeqFormDto {
  numberOfChildren: number;
  creditCosts: number;
  housingCosts: number;
  income: number;
  miscExpenses: number;
  employment: Employment;
  studentLoan: number;
  housingType: Housing;
}

export interface KalpAnswersFI {
  occupation: Occupation;
  monthlyNetIncome: number;
  nameOfEmployer?: string;
  employmentStartDate: Date;
  employmentEndDate: Date;
  martialStatus: MartialStatus;
  typeOfAccommodation: TypeOfAccommodation;
  amountOfChildren: number;
  rentOrFeePerMonth: number;
  totalMortgage?: number;
  mortgagePaymentPerMonth?: number;
  totalAmountOfOtherLoans: number;
  monthlyObligationForOtherLoans: number;
  monthlyLivingExpenses: number;
  currencyCode: CurrencyCode;
}

export interface KalpAnswersNO {
  monthlyNetIncome: number;
  typeOfLiving: Housing;
  numberOfAdults: number;
  numberOfChildren: number;
  monthlyMortgageCost: number;
  currencyCode: CurrencyCode;
}

export enum Occupation {
  FULL_TIME_EMPLOYMENT = 'FULL_TIME_EMPLOYMENT',
  PART_TIME_EMPLOYMENT = 'PART_TIME_EMPLOYMENT',
  ENTREPRENEUR = 'ENTREPRENEUR',
  STUDENT = 'STUDENT',
  UNEMPLOYED = 'UNEMPLOYED',
  OTHER = 'OTHER',
  SELF_EMPLOYED = 'SELF_EMPLOYED',
  FIX_TERM_EMPLOYMENT = 'FIX_TERM_EMPLOYMENT',
  RETIRED = 'RETIRED',
}

export enum MartialStatus {
  MARRIED = 'MARRIED',
  SINGLE = 'SINGLE',
  COHABITANT = 'COHABITANT',
}

export enum TypeOfAccommodation {
  OWNER = 'OWNER',
  RENT = 'RENT',
  PARTNER_OWNS_PROPERTY = 'PARTNER_OWNS_PROPERTY',
  OTHER = 'OTHER',
}

// This is old, should be replaced by Occupation
export enum Employment {
  PERMANENT = 'PERMANENT',
  PART_TIME = 'PART_TIME',
  STUDENT = 'STUDENT',
  ENTREPRENEUR = 'ENTREPRENEUR',
  RETIRED = 'RETIRED',
  UNEMPLOYED = 'UNEMPLOYED',
}

export enum KalpStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
}

export enum Housing {
  OWN = 'OWN', // @deprecated
  RENTAL = 'RENTAL',
  ROOMER = 'ROOMER', // @deprecated
  WITH_PARENTS = 'WITH_PARENTS', // @deprecated
  N_A = 'N_A', // @deprecated
  CONDO = 'CONDO',
  HOUSE = 'HOUSE',
}

// Backend driven Kalps
export enum KalpInfoReason {
  INFO = 'INFO',
  REJECTED = 'REJECTED',
}

export enum KalpQuestionType {
  LEQ_ANSWER_HOUSING_COSTS = 'LEQ_ANSWER_HOUSING_COSTS',
  LEQ_ANSWER_NET_MONTHLY_INCOME = 'LEQ_ANSWER_NET_MONTHLY_INCOME',
  LEQ_ANSWER_OCCUPATION = 'LEQ_ANSWER_OCCUPATION',
  LEQ_ANSWER_MISC_COSTS = 'LEQ_ANSWER_MISC_COSTS',
  LEQ_ANSWER_COST_OF_LOANS = 'LEQ_ANSWER_COST_OF_LOANS',
  LEQ_ANSWER_NUMBER_OF_KIDS = 'LEQ_ANSWER_NUMBER_OF_KIDS',
  LEQ_ANSWER_NUMBER_OF_ADULTS = 'LEQ_ANSWER_NUMBER_OF_ADULTS',
  LEQ_ANSWER_TYPE_OF_HOUSING = 'LEQ_ANSWER_TYPE_OF_HOUSING',
}
